import {
    JobAlternativeCertificationDto,
    CertificationWithRelated
} from 'src/app/shared/components/job-qualifications/models/certification-with-related.model';

/**
 * Get alternative certification names for a given source certification ID.
 * Maps target certification IDs from effectiveAlternatives to their names from availableRelatedCertifications.
 * Used to display alternative certifications in read-only mode when feature flag is enabled.
 *
 * @param sourceCertificationId - The ID of the source (required) certification
 * @param effectiveAlternatives - Array of effective alternative certification mappings (hierarchy-resolved from backend)
 * @param availableRelatedCertifications - Array of all certifications with their related certifications
 * @returns Array of certification names that can be used as alternatives
 */
export function getAlternativesForCertification(
    sourceCertificationId: number,
    effectiveAlternatives: JobAlternativeCertificationDto[],
    availableRelatedCertifications: CertificationWithRelated[]
): string[] {
    // Find the alternative mapping for this source certification
    const alternativeMapping = effectiveAlternatives.find((alt) => alt.sourceCertificationId === sourceCertificationId);

    if (!alternativeMapping || !alternativeMapping.targetCertificationIds?.length) {
        return [];
    }

    // Find the available certifications for this source
    const availableCerts = availableRelatedCertifications.find(
        (cert) => cert.certificationId === sourceCertificationId
    );

    if (!availableCerts || !availableCerts.relatedCertifications?.length) {
        return [];
    }

    // Map target IDs to certification names
    const targetIds = alternativeMapping.targetCertificationIds;
    const alternativeNames = availableCerts.relatedCertifications
        .filter((cert) => targetIds.includes(cert.id))
        .map((cert) => cert.title);

    return alternativeNames;
}
